import { Outlet, useLocation } from "react-router-dom";
import Banner from "../modules/common/Banner";
import { paths, pathSegments } from "../lib/router";

export default function PrimaryLayout() {
  const location = useLocation();
  const pathComponents = location.pathname.split("/");

  const isSearch = location.pathname === paths.accountSearch;
  const isDetails =
    pathComponents.length === 3 && pathComponents[1] === pathSegments.account;

  return (
    <>
      <header>
        <Banner isSearch={isSearch} isDetails={isDetails} />
      </header>
      <Outlet />
    </>
  );
}
